export default [
    {
        path: '/pages/scm/couponMarket',
        name: '/pages/scm/couponMarket',
        component: () => import('@/views/scm/couponMarketList.vue')
    },
    {
        path: '/pages/scm/couponPropertyPoolManage',
        name: '/pages/scm/couponPropertyPoolManage',
        component: () => import('@/views/scm/couponPropertyPoolManageList.vue')
    },
    {
        path: '/pages/scm/couponRule',
        name: '/pages/scm/couponRule',
        component: () => import('@/views/scm/couponRuleList.vue')
    },
    {
        path: '/pages/scm/couponPropertyPoolDetail',
        name: '/pages/scm/couponPropertyPoolDetail',
        component: () => import('@/views/scm/couponPropertyPoolDetailList.vue')
    },
    {
        path: '/pages/scm/couponPropertyUserManage',
        name: '/pages/scm/couponPropertyUserManage',
        component: () => import('@/views/scm/couponPropertyUserManageList.vue')
    },
    {
        path: '/pages/scm/couponPropertyUserDetail',
        name: '/pages/scm/couponPropertyUserDetail',
        component: () => import('@/views/scm/couponPropertyUserDetailList.vue')
    },
    {
        path: '/pages/scm/integralConfigManage',
        name: '/pages/scm/integralConfigManage',
        component: () => import('@/views/scm/integralConfigManageList.vue')
    },
    {
        path: '/pages/scm/integralRule',
        name: '/pages/scm/integralRule',
        component: () => import('@/views/scm/integralRuleList.vue')
    },
    {
        path: '/pages/scm/integralGiftDetailManage',
        name: '/pages/scm/integralGiftDetailManage',
        component: () => import('@/views/scm/integralGiftDetailManageList.vue')
    },
    {
        path: '/pages/scm/communityIntegral',
        name: '/pages/scm/communityIntegral',
        component: () => import('@/views/scm/communityIntegralList.vue')
    },
    {
        path: '/pages/scm/gold',
        name: '/pages/scm/gold',
        component: () => import('@/views/scm/goldList.vue')
    },
    {
        path: '/pages/reserve/reserveCatalogManage',
        name: '/pages/reserve/reserveCatalogManage',
        component: () => import('@/views/scm/reserveCatalogManageList.vue')
    },
    {
        path: '/pages/reserve/reserveParamsManage',
        name: '/pages/reserve/reserveParamsManage',
        component: () => import('@/views/scm/reserveParamsManageList.vue')
    },
    {
        path: '/pages/reserve/reserveDiningManage',
        name: '/pages/reserve/reserveDiningManage',
        component: () => import('@/views/scm/reserveDiningManageList.vue')
    },
    {
        path: '/pages/reserve/reserveServiceManage',
        name: '/pages/reserve/reserveServiceManage',
        component: () => import('@/views/scm/reserveServiceManageList.vue')
    },
    {
        path: '/views/scm/addReserveDining',
        name: '/views/scm/addReserveDining',
        component: () => import('@/views/scm/addReserveDiningList.vue')
    },
    {
        path: '/views/scm/editReserveDining',
        name: '/views/scm/editReserveDining',
        component: () => import('@/views/scm/editReserveDiningList.vue')
    },
    {
        path: '/views/scm/doDining',
        name: '/views/scm/doDining',
        component: () => import('@/views/scm/doDiningList.vue')
    },
    {
        path: '/views/scm/addReserveService',
        name: '/views/scm/addReserveService',
        component: () => import('@/views/scm/addReserveServiceList.vue')
    },
    {
        path: '/views/scm/ownerDining',
        name: '/views/scm/ownerDining',
        component: () => import('@/views/scm/ownerDiningList.vue')
    },
    {
        path: '/views/scm/reserveCatalogManage',
        name: '/views/scm/reserveCatalogManage',
        component: () => import('@/views/scm/reserveCatalogManageList.vue')
    },
    {
        path: '/views/scm/editReserveService',
        name: '/views/scm/editReserveService',
        component: () => import('@/views/scm/editReserveServiceList.vue')
    },
    {
        path: '/pages/reserve/reserveOrder',
        name: '/pages/reserve/reserveOrder',
        component: () => import('@/views/scm/reserveOrderList.vue')
    },
    {
        path:'/pages/reserve/reserveConfirm',
        name:'/pages/reserve/reserveConfirm',
        component: () => import('@/views/scm/reserveConfirmList.vue')
        },
]